module.exports = __webpack_public_path__ + "776c43132451382b7b102e232dfc7ac1.fbx";